app.service("InfoService", ['$rootScope', function ($rootScope) {

    const modelConstructor = $rootScope.model_constructor;

    const RouteChoice = modelConstructor.RouteChoice;

    const InfoModel = modelConstructor.extend(modelConstructor.RouteModel, {
        name: "Info",
        id: "info",
        navigation_pointer: "info_id",
        choice_order: ['fira_level_h', 'hinge_drawer_information']
    });

    this.factory = new modelConstructor.RouteFactory({

        choices: {
            fira_level_h: new RouteChoice({
                name: "Fira Level H"
            }),
            hinge_drawer_information: new RouteChoice({
                name: "Hinge Drawer Information"
            })
        },

        birth: function (values) {
            return new InfoModel(values);
        }
    });

}]);